import { PopoutSize, RememberedPopoutSize } from "./usePopoutFit";

type Inputs = {
  /** A size the user chose for this step on an earlier pop-out. */
  remembered?: RememberedPopoutSize;
  /** The modal box the dialog is docked in right now. */
  docked?: PopoutSize;
  wantedWidth: number;
  /** The current height ask. Differing from `remembered.fitsHeightPx` means outgrown. */
  fitHeight: number;
  /** The height to open at when nothing is remembered or docked. */
  wantedHeight: number;
};

/**
 * The inner size to open a pop-out at: the size the user chose, else the docked one,
 * else what the content computes to.
 *
 * While a docked box exists the height comes from it, never from a computed one:
 * opening at the ask draws the window full size and lets the fit shrink it back. A
 * stale remembered height is given up to the docked one for the same reason.
 */
export const popoutOpenSize = ({
  remembered,
  docked,
  wantedWidth,
  fitHeight,
  wantedHeight,
}: Inputs): PopoutSize => ({
  width: remembered?.width ?? docked?.width ?? wantedWidth,
  height:
    remembered && remembered.fitsHeightPx === fitHeight
      ? remembered.height
      : (docked?.height ?? wantedHeight),
});
